import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { SchoolFeedbackCreateRequestDTO, SchoolFeedbackDTO, SchoolFeedbackUpdateRequestDTO, SchoolFeedbackDeleteRequestDTO, SchoolFeedbackReadByIdRequestDTO, SchoolFeedbackReadByMasterIdRequestDTO, SchoolFeedbackList, SchoolFeedbackReadByTeacherIdRequestDTO, SchoolFeedbackReadBySchoolIdRequestDTO } from "./school-feedback.interface";
import { SchoolFeedback_Create, SchoolFeedback_Update, SchoolFeedback_Delete, SchoolFeedback_ReadById, SchoolFeedback_ReadByMasterId, SchoolFeedback_ReadByTeacherId, SchoolFeedback_ReadBySchoolId, SchoolFeedback_ReadAll } from "src/app/GlobalVariable";

@Injectable({
  providedIn: 'root'
})
export class SchoolFeedbackService {

  private http = inject(HttpClient);


  SchoolFeedback_Create(data: SchoolFeedbackCreateRequestDTO): Observable<SchoolFeedbackDTO> {
    return this.http.post<SchoolFeedbackDTO>(SchoolFeedback_Create, data);
  }

  SchoolFeedback_Update(data: SchoolFeedbackUpdateRequestDTO): Observable<SchoolFeedbackDTO> {
    return this.http.post<SchoolFeedbackDTO>(SchoolFeedback_Update, data);
  }

  SchoolFeedback_Delete(data: SchoolFeedbackDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(SchoolFeedback_Delete, data);
  }

  SchoolFeedback_ReadById(data: SchoolFeedbackReadByIdRequestDTO): Observable<SchoolFeedbackDTO> {
    return this.http.post<SchoolFeedbackDTO>(SchoolFeedback_ReadById, data);
  }

 
  SchoolFeedback_ReadByMasterId(data: SchoolFeedbackReadByMasterIdRequestDTO): Observable<SchoolFeedbackList> {
    return this.http.post<SchoolFeedbackList>(SchoolFeedback_ReadByMasterId, data);
  }


  SchoolFeedback_ReadByTeacherId(data: SchoolFeedbackReadByTeacherIdRequestDTO): Observable<SchoolFeedbackList> {
    return this.http.post<SchoolFeedbackList>(SchoolFeedback_ReadByTeacherId, data);
  }


  SchoolFeedback_ReadBySchoolId(data: SchoolFeedbackReadBySchoolIdRequestDTO): Observable<SchoolFeedbackList> {
    return this.http.post<SchoolFeedbackList>(SchoolFeedback_ReadBySchoolId, data);
  }


  SchoolFeedback_ReadAll(): Observable<SchoolFeedbackList> {
    return this.http.get<SchoolFeedbackList>(SchoolFeedback_ReadAll);
  }
}